import(/* webpackMode: "eager", webpackExports: ["toast","error"] */ "/vercel/path0/node_modules/.pnpm/sonner@2.0.7_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["CustomButton"] */ "/vercel/path0/src/components/login.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["getPhoneNumber","getPassword","getCode"] */ "/vercel/path0/src/lib/telegramAuthHelpers.tsx");
